export const SAVED_GAMES_LOCAL_STORAGE_KEY: string = "gamesSavedByUser";